import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../store/appState';
import {makeGetActiveTeammateForEmail} from '../../../store/data/teammates/teammatesSelectors';
import {CustomAttributeTeammate} from './customAttributeTeammate';

/*
 * Props.
 */

interface CustomAttributeTeammateContainerProps {
  teammateEmail: string;
}

/*
 * Selectors.
 */

function getEmail(_state: AppState, props: CustomAttributeTeammateContainerProps) {
  return props.teammateEmail;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CustomAttributeTeammateContainerProps>()(() => {
  const getTeammateForEmail = makeGetActiveTeammateForEmail(getEmail);
  return {
    teammate: getTeammateForEmail,
  };
});

export const CustomAttributeTeammateContainer = connect(mapStateToProps)(CustomAttributeTeammate);
